import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPrivacyPolicies } from '../redux/slice/privacyPolicy.slice';
import gsap from 'gsap';
import 'react-quill-new/dist/quill.snow.css';
import { Helmet } from 'react-helmet-async';
import LegalDocumentPreview from '../components/legal/LegalDocumentPreview';

export default function PrivacyPolicy() {
    const dispatch = useDispatch();
    const { policies, loading } = useSelector((state) => state.privacyPolicy);

    useEffect(() => {
        dispatch(fetchPrivacyPolicies());
    }, [dispatch]);

    useEffect(() => {
        const ctx = gsap.context(() => {
            gsap.from('.policy-reveal', {
                y: 28,
                opacity: 0,
                duration: 0.75,
                stagger: 0.07,
                ease: 'power3.out',
                clearProps: 'all',
            });
        });
        return () => ctx.revert();
    }, []);


    return (
        <>
            <Helmet>
                <title>Privacy Policy | CUBE GAMES</title>
                <meta name="description" content="Read the Cube Games Privacy Policy to understand how we collect, protect, and use your personal data and transaction security." />
                <meta name="keywords" content="privacy policy, data protection, GDPR compliant, user data security" />
                <link rel="canonical" href="https://cubegames.ca/privacy" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Privacy Policy | CUBE GAMES" />
                <meta property="og:description" content="Read the Cube Games Privacy Policy to understand how we collect, protect, and use your personal data and transaction security." />
                <meta property="og:url" content="https://cubegames.ca/privacy" />
            </Helmet>

            <LegalDocumentPreview
                variant="privacy"
                sections={policies || []}
                loading={loading}
                revealClass="policy-reveal"
            />
        </>
    );
}
